import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider";

const Header = () => {
    const { user, logOut, setUser } = useContext(AuthContext);

    const img = user?.photoURL;

    const handleLogOut = () => {
        setUser(null);
        logOut()
            .then(() => { })
            .catch(error => console.error(error))
    }
    return (
        <div className="relative">
            <div className="navbar bg-blueAss sticky top-0 pt-3 text-white max-w-1440">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content text-black mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <li><Link to='/'>Home</Link></li>
                            <li><Link to='/services'> My services</Link></li>
                            <li><Link to='/blog'>Blog</Link></li>
                            <>
                                {
                                    user?.uid && <span className="">
                                        <li><Link to={`/my-reviews/${user.email}`}>My Reviews</Link></li>
                                        <li><Link to='/add-service'>Add Service</Link></li>
                                    </span>
                                }
                            </>
                        </ul>
                    </div>
                    <a className="btn btn-ghost normal-case text-xl"><span className="text-orange">Cloud</span>Kichen</a>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        <li className="hover:text-yellow"><Link to='/'>Home</Link></li>
                        <li className="hover:text-yellow"><Link to='/services'> My services</Link></li>
                        <li className="hover:text-yellow"><Link to='/blog'>Blog</Link></li>
                        <li className="hover:text-yellow"><Link to='/color'>color</Link></li>
                        <>
                            {
                                user?.uid && <span className="flex">
                                    <li className="hover:text-yellow"><Link to={`/my-reviews/${user.email}`}>My Reviews</Link></li>
                                    <li className="hover:text-yellow"><Link to='/add-service'>Add Service</Link></li>
                                </span>
                            }
                        </>
                    </ul>
                </div>
                <div className="navbar-end">
                    <>
                        {
                            user?.uid ?
                                <Link onClick={handleLogOut} className="btn bg-orange mr-5 normal-case text-lg">Log out</Link>
                                :
                                <Link to='/login' className="btn bg-orange mr-5 normal-case text-lg">Login/ Sign Up</Link>
                        }
                    </>


                    {/* <Link to='/login' className="btn bg-orange mr-5 normal-case text-lg">Login/ Sign Up</Link> */}
                </div>
            </div>
        </div>


    );
}
export default Header;